import React from 'react';
import { Input, Select } from 'antd';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";
const InputGroup = Input.Group;
const { Option } = Select;
export default class ComboBoxEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e) {
        let sourceValue = {
            ...this.props.source.value,
            inputValue: e.target.value
        };
        this.props.source.value = sourceValue;
        this.setState({});
    }

    onSelect(value) {
        let sourceValue = {
            ...this.props.source.value,
            selectValue: value
        };
        this.props.source.value = sourceValue;
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    render() {
        let source = this.props.source;
        let value = source.value || {};
        let values = source.values || [];

        let inputValue = value.inputValue;
        let selectValue = value.selectValue;

        let input;
        let sel = <Select style={{
            width: "100px"
        }} value={selectValue} onChange={e => this.onSelect(e)}>
            {values.map((item, i) => {
                return <Option key={i} value={item.value}>{item.alias || item.value}</Option>;
            })}
        </Select>
        if (source.before) {
            input = <Input value={inputValue}
                onChange={e => this.onChange(e)}
                placeholder={source.placeholder || ""}
                addonBefore={sel}
            />
        } else {
            input = <Input value={inputValue}
                onChange={e => this.onChange(e)}
                placeholder={source.placeholder || ""}
                addonAfter={sel}
            />
        }
        return input;
    }
}

PropertyGridUtils.register("combo", (source, propertyGrid) => <ComboBoxEditor source={source} propertyGrid={propertyGrid} />);